import React from 'react'

class AssignedZoneList extends React.Component {
  render() {
    return (
      <div className="table-responsive">
        <table className="table table-sm table-stripped">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Zona</th>
              <th scope="col">Descripción</th>
              <th scope="col">Color</th>
              <th scope="col">Mapa</th>
            </tr>
          </thead>
          <tbody>
            {this.props.Zones.map(zone => (
              <tr>
                <th scope="row">{zone.Zone}</th>
                <th scope="row">{zone.Description}</th>
                <th scope="row">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div
                      style={{
                        width: '30px',
                        height: '30px',
                        backgroundColor: zone.Color,
                        border: '1px solid #000', // Optional border for better visibility
                        marginRight: '10px', // Adds some space between the color box and the text
                      }}
                    ></div>
                  </div>
                </th>
                <th scope="row">{zone.Map}</th>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default AssignedZoneList
